// 토스트 알림 (기획서 12.3: 저장 실패 등을 조용히 삼키지 않고 명확히 알림)
let _timer = null;

export function toast(message, duration = 3200) {
  let el = document.querySelector('.toast');
  if (el) el.remove();
  el = document.createElement('div');
  el.className = 'toast';
  el.textContent = message;
  document.body.appendChild(el);
  if (_timer) clearTimeout(_timer);
  _timer = setTimeout(() => {
    el.style.opacity = '0';
    el.style.transition = 'opacity 0.3s ease';
    setTimeout(() => el.remove(), 320);
  }, duration);
}
